import type { RichTextDocument } from '../RichTextContent';

export function isRichTextEmpty(text: RichTextDocument | undefined) {
  return !text || !text.content || text.content.length === 0;
}
